<template>
  <a-modal width="50%" :label-col="4" :wrapper-col="14" :visible="visible" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>修改地址</b>
    </a-divider>
    <a-form-model ref="formRef" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">

         <a-form-model-item label="收货人" prop="realName" >
            <a-input v-model="form.realName" placeholder="请输入收货人" />
        </a-form-model-item>

         <a-form-model-item label="收货人电话" prop="mobile" >
            <a-input v-model="form.mobile" placeholder="请输入收货人电话" />
        </a-form-model-item>

        <a-form-model-item label="地区选择" >
             <a-cascader :options="options" v-model="valueName" placeholder="地区选择" @change="onChange" />
        </a-form-model-item>
        <a-form-model-item label="详细地址" prop="detailedAddress" >
            <a-input v-model="form.detailedAddress" placeholder="请输入详细地址" />
        </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.确定')}}
          </a-button>
          <a-button type="dashed" @click="onClose">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateDelivery} from  '@/api/order/sell'
import {levelList}  from '@/common/areadata.js'
import { dateTimeStr } from '@/common/date.js'
export default {
  name: 'ModifyAddress',
  data () {
    return {
    options:levelList,
    valueName:null,
      addrList: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,
        oldAddress:null,
        newAddress:null,
        realName:null,
        mobile:null
      },
      // 1增加,2修改
      formType: 1,
      visible: false,
      rules: {
        
        realName: [
          { required: true, message: '联系人', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '联系人手机号', trigger: 'blur' }
        ],
        detailedAddress: [
          { required: true, message: '详细地址不能为空', trigger: 'blur' }
        ],

      }
    }
  },
  methods: {
    open(row){
        this.visible = true
        this.getDetailes(row)
        console.log(row);
        
    },

    // 获取详情
    getDetailes(row){
      let data = JSON.parse(row.addressDetail)
      console.log(data,'data');
      let list = []
      list[0] = data.areapId.toString()
      list[1] = data.areacId.toString()
      list[2] = data.areaxId.toString()
      
      this.form = data
      this.form.id = row.id
      this.valueName = list

    },

    onChange(row){
        if(row && row.length>0){
            this.form.areapId = row[0]
            this.form.areacId = row[1]
            this.form.areaxId = row[2]
            this.form.areap = this.findValueByLabel(levelList, row[0]);
            this.form.areac = this.findValueByLabel(levelList, row[1]);
            this.form.areax = this.findValueByLabel(levelList, row[2]);
        }
        
    },
    // 取消按钮
    onClose () {
      this.visible = false
      this.reset()
    },
    // 表单重置
    reset () {
     
      this.form = {
        id: null,
        oldAddress:null,
        newAddress:null,
      }

    },
    /** 提交按钮 */
    submitForm () {
      if (this.valueName && this.valueName.length>0) {
        this.$delete(this.form, 'time')
        console.log(this.form,'this.form');
        
        this.$refs.formRef.validate(valid => {
          if (valid) {
            updateDelivery(this.form).then(response => {
                if(response){
                    this.visible = false
                    this.$emit('setUpdate')
                }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            return false
          }
        });
      }else{
        this.$message.error('请选择地区')
      }
    },

    findValueByLabel(nodeList, targetLabel) {
        for (const node of nodeList) {
            if (node.value == targetLabel) {
                return node.label; // 匹配成功，返回 label
            }
            if (node.children && node.children.length > 0) {
                // 递归遍历子节点
                const result = this.findValueByLabel(node.children, targetLabel);
                if (result !== null) { // 子节点中找到结果
                    return result;
                }
            }
        }
        return null; // 未找到
    }
  }
}
</script>
<style  lang="less" scoped>
.info-table {
  tr {
    height: 50px;
  }
  td {
    display: table-cell;
    vertical-align: top;
    font-size: 16px;
  }
  .first {
    width: 120px;
  }
  .data {
    width: 280px;
  }
}
</style>
